import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MessagingService } from '../../../../services/messagingServices/messaging.service';
import { IAlertService } from '../../../../iservices/iAlert';

export interface IAddAwsEmailTemplateData {
  TemplateName?: string;
  SubjectPart?: string;
  HtmlPart?: string;
  TextPart?: string;
  isEdit?: boolean;
}

@Component({
  selector: 'app-add-aws-email-template',
  templateUrl: './add-aws-email-template.component.html',
  styleUrls: ['./add-aws-email-template.component.scss']
})
export class AddAwsEmailTemplateComponent {
  templateForm: FormGroup;
  isEdit = false;

  constructor(
    public dialogRef: MatDialogRef<AddAwsEmailTemplateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IAddAwsEmailTemplateData,
    private formBuilder: FormBuilder,
    private messagingService: MessagingService,
    @Inject('IAlertService') private alertService: IAlertService
  ) {
    this.isEdit = !!(data && data.isEdit);
    this.templateForm = this.formBuilder.group({
      TemplateName: [{ value: (data && data.TemplateName) || '', disabled: this.isEdit }, Validators.required],
      SubjectPart: [(data && data.SubjectPart) || '', Validators.required],
      HtmlPart: [(data && data.HtmlPart) || '', Validators.required],
      TextPart: [(data && data.TextPart) || '']
    });
  }

  submit(): void {
    if (this.templateForm.invalid) { return; }
    const payload = { ...this.templateForm.getRawValue() };
    const request$ = this.isEdit
      ? this.messagingService.updateAwsEmailTemplate(payload.TemplateName, payload)
      : this.messagingService.createAwsEmailTemplate(payload);
    request$.subscribe(() => {
      this.alertService.successMsg(this.isEdit ? 'Template updated successfully' : 'Template created successfully', false);
      this.dialogRef.close(payload);
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
